import { Availability } from '../../lib/types/models/availability/availability'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getStaffAvailabilities = async (id: number) => {
  const res = await restApiClient
    .url(constructApiUrl(API.staffs.getAvailabilies.url, { id }))
    .get<Availability[]>()

  return res.map((availability) => ({
    ...availability,
    start: new Date(availability.startDate),
    end: new Date(availability.endDate)
  }))
}
